import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'teamName',
    name: 'page.team.col-name',
  },
];
